import React, { Component, Fragment } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { get } from 'lodash-es';
import ReactLoading from 'react-loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isProd } from '../../../../utilities/UrlPaths';
import { errorLoadingCatalogText } from '../../../../utilities/StaticText';
import InlineAlert from '../../../../utilities/form-components/InlineAlert';
import getPackageID from '../../diy-services/getPackageId';
import Step2Dropzone from './Step2Dropzone';

// This represents the un-uploaded state of BIN Step2
class Step2PreUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      hasUploadErrors: false,
      loading: true
    };
  }

  async componentDidMount() {
    const {
      match: {
        params: { catalogID }
      }
    } = this.props;

    const packageID = await getPackageID(catalogID);

    if (packageID) {
      this.setState({ packageID, loading: false });
    } else {
      this.setState({ loading: false, error: true });
    }
  }

  // Download a spreadsheet model based on the auction type and format selected
  downloadModel = () => {
    window.location.href = 'https://s3.amazonaws.com/docs.invaluableauctions/buy-it-now-model.xls';
  };

  downloadSnapshot = () => {
    const {
      match: {
        params: { catalogID }
      }
    } = this.props;

    window.location.href = `/cps/app/snapshot/${catalogID}/lot-data?version=v2`;
  };

  setUploadErrors = hasUploadErrors => {
    this.setState({ hasUploadErrors });
  };

  /**
   * The user decided they wanted to add items individually - set step tracker to 6
   * and take them to the add lot page
   */
  skipToSummary = async () => {
    const {
      match: {
        params: { catalogID, groupID, type }
      }
    } = this.props;

    await axios.post(`/cps/app/diy-step-tracker/${catalogID}`, 5, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    this.props.history.push(`/session/${type}/${groupID}/${catalogID}/lot/0`);
  };

  render() {
    const { error, loading } = this.state;

    if (loading) {
      return <ReactLoading className="loading-spinner" type="spin" color="black" />;
    }

    if (error) {
      return <InlineAlert baseText={errorLoadingCatalogText} />;
    }

    const {
      handleUpload,
      location: { state },
      match: {
        params: { catalogID, groupID }
      }
    } = this.props;
    const { hasUploadErrors, packageID } = this.state;

    const isEditingSession = get(state, 'linkedFrom', null) === 'step5';

    return (
      <div className="mt-4">
        <Row>
          {/* Start Left Column */}
          <Col xs={8}>
            {isEditingSession ? (
              <Fragment>
                <h3 className="text-transform-unset">
                  To edit multiple items that you&apos;ve already uploaded, follow the three easy
                  steps below.
                </h3>
                <p>
                  If you are simply adding new items, skip to the last step and upload the
                  spreadsheet from your computer.
                </p>
                <p className="mb-0">
                  1.
                  <Button color="link" onClick={() => this.downloadSnapshot()}>
                    &nbsp;Download a spreadsheet snapshot
                  </Button>
                  &nbsp;of your current catalog.
                </p>
                <p className="mb-0">
                  2. Edit your items in Excel. New items will be added, existing items don&apos;t
                  need to be re-included if they are not being changed.
                </p>
                <p>3. Upload your spreadsheet:</p>
              </Fragment>
            ) : (
              <Fragment>
                <h3>Upload Items</h3>
                <p>
                  Drag &amp; drop the items spreadsheet in the uploader box below (or click
                  &quot;choose file(s) from your computer&quot; to find your file)
                </p>

                <p>
                  You may also upload items individually by choosing &nbsp;
                  <Button color="link" role="link" onClick={() => this.skipToSummary()}>
                    <FontAwesomeIcon icon="plus" />
                    &nbsp;Add single item
                  </Button>
                </p>
              </Fragment>
            )}

            <Step2Dropzone
              acceptedFileList=".csv,.xls,.xlsx"
              catalogID={catalogID}
              handleUpload={handleUpload}
              setUploadErrors={this.setUploadErrors}
              multiple={false}
              packageID={packageID}
            />
          </Col>

          {/* Start Right Column */}
          <Col xs={4}>
            <h3 className="mb-0">Spreadsheet Requirements</h3>
            <p className="mb-4">
              <Button color="link" onClick={() => this.downloadModel()}>
                Download the spreadsheet model
              </Button>
              &nbsp;and enter your item details to the template.
            </p>
            <p className="mb-0">For more tips and tricks, please read our</p>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://invaluable.uberflip.com/buy-now/preparing-your-catalog-for-buy-now-2"
            >
              upload tip sheet
            </a>
            .
          </Col>
        </Row>

        {!hasUploadErrors && (
          <div className="mt-4">
            {isEditingSession ? (
              <Link to={`/session/bin/${parseInt(groupID, 10)}/${parseInt(catalogID, 10)}/5`}>
                Cancel &amp; Return to Summary
              </Link>
            ) : (
              <Link to="/my-auctions/current">Save &amp; Exit</Link>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Step2PreUpload);
